import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Grid, Accordion } from 'semantic-ui-react';

import { localGet, localSet } from '../../utils/localStorage';
import TableWithFetch from '../reusable/TableWithFetch';
import alarmsSchema from '../../schemas/alarms';
import activeAlarmsShape from '../../shapes/activeAlarmsShape';
import completedAlarmsShape from '../../shapes/completedAlarmsShape';
import LeftAlignedAccordionHeaderTitle from '../reusable/LeftAlignedAccordionHeaderTitle';

const activeAlarmsSchema = {};
Object.keys(alarmsSchema).forEach((name) => {
  if (name !== 'end') activeAlarmsSchema[name] = alarmsSchema[name];
});

class Alarms extends Component {
  static propTypes = {
    activeAlarms: PropTypes.shape({
      byId: PropTypes.shape({}).isRequired,
      allIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    completedAlarms: PropTypes.shape({
      byId: PropTypes.shape({}).isRequired,
      allIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    getAlarms: PropTypes.func.isRequired,
    loadMore: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showActiveAlarms: localGet('showActiveAlarms', true),
      showEndedAlarms: localGet('showEndedAlarms', true),
    };
    this.handleActiveAccordion = this.handleActiveAccordion.bind(this);
    this.handleEndedAccordion = this.handleEndedAccordion.bind(this);
  }

  componentWillUnmount() {
    // this.props.clearAlarmsTables();
  }

  handleActiveAccordion() {
    this.setState((prevState) => {
      const showActiveAlarms = !prevState.showActiveAlarms;
      localSet('showActiveAlarms', showActiveAlarms);
      return { showActiveAlarms };
    });
  }

  handleEndedAccordion() {
    this.setState((prevState) => {
      const showEndedAlarms = !prevState.showEndedAlarms;
      localSet('showEndedAlarms', showEndedAlarms);
      return { showEndedAlarms };
    });
  }

  render() {
    const {
      activeAlarms, completedAlarms, getAlarms, loadMore, t,
    } = this.props;
    const { showActiveAlarms, showEndedAlarms } = this.state;

    return (
      <Grid padded>
        <Grid.Row>
          <Accordion fluid>
            <LeftAlignedAccordionHeaderTitle
              active={showActiveAlarms}
              onClick={this.handleActiveAccordion}
              label={t('alarms.active')}
            />
            <Accordion.Content active={showActiveAlarms}>
              <TableWithFetch
                fetchAction={() => getAlarms('active')}
                isLoading={activeAlarms.isPending}
                content={activeAlarms}
                shape={activeAlarmsShape}
              />
            </Accordion.Content>
          </Accordion>
        </Grid.Row>
        <Grid.Row>
          <Accordion fluid>
            <LeftAlignedAccordionHeaderTitle
              active={showEndedAlarms}
              onClick={this.handleEndedAccordion}
              label={t('alarms.completed')}
            />
            <Accordion.Content active={showEndedAlarms}>
              <TableWithFetch
                fetchAction={() => getAlarms('completed')}
                isLoading={completedAlarms.isPending}
                content={completedAlarms}
                shape={completedAlarmsShape}
                loadMoreAction={() => loadMore('completed')}
              />
            </Accordion.Content>
          </Accordion>
        </Grid.Row>
      </Grid>
    );
  }
}

export default translate()(Alarms);



// WEBPACK FOOTER //
// ./src/components/Alarms/Alarms.js